jQuery(document).ready(function($) {
    /** Mobile Menu Main Toggle */
    let scrollTop = 0;
    $('.mobile-menu-icon, .mobile-menu-close').on('click', function(e) {
        $('.mobile-menu-icon').toggleClass('mobile-menu-icon-active');
        $('.main-navigation').toggleClass('mobile-menu-active');
        $('body').toggleClass('mobile-menu-fixed');
  
        if ($('.main-navigation').hasClass('mobile-menu-active')) {
            scrollTop = $(window).scrollTop();
  
            $('body').css({
                position: 'fixed',
                top: -scrollTop + 'px',
                width: '100%'
            });
  
        } else {
            $('body').css({
                position: '',
                top: ''
            });
            $(window).scrollTop(scrollTop);
        }
  
        e.preventDefault();
    });

    /** Mobile Submenu Toggle */
    $('.am-submenu-toggle').on('click', function(e) {
        let submenuList = $(this).siblings('.am-submenu-list');
        let parentLi = $(this).closest('li');
        if (parentLi.hasClass('active')) {
          parentLi.removeClass('active');
        } else {
          parentLi.addClass('active');
        }
        submenuList.toggleClass('submenu-active');
        return false;
    });

    // Toggles the visibility of the next nav menu
    $('.footer-flex .widget_block').click(function() {
      $(this).nextAll('.widget_nav_menu').slideToggle();
      $(this).toggleClass('active');
    });

    // Toggle 'active' class on blog categories
    $('.filter-option').click(function() {
        $('.categories-flex').toggleClass('active');
    });

    /** Slick Slider */
    function initializeSlickSlider() {
        if ($('.tablet-carousel').length && $(window).width() < 1200) {
        $('.uagb-container-inner-blocks-wrap .tablet-carousel, .tablet-carousel .uagb-container-inner-blocks-wrap').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 3000,
            prevArrow: '<div class="prevNav"><svg fill="#ffffff" height="24px" width="24px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 59.414 59.414" xml:space="preserve" stroke="#ffffff"> <g id="SVGRepo_bgCarrier" stroke-width="0"/> <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/> <g id="SVGRepo_iconCarrier"> <polygon points="45.268,1.414 43.854,0 14.146,29.707 43.854,59.414 45.268,58 16.975,29.707 "/> </g> </svg></div>',
			nextArrow: '<div class="nextNav"><svg fill="#ffffff" height="24px" width="24px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 59.414 59.414" xml:space="preserve" stroke="#ffffff"> <g id="SVGRepo_bgCarrier" stroke-width="0"/> <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"/> <g id="SVGRepo_iconCarrier"> <polygon points="15.561,0 14.146,1.414 42.439,29.707 14.146,58 15.561,59.414 45.268,29.707 "/> </g> </svg></div>',
            responsive: [
            {
                breakpoint: 768,
                settings: {
                slidesToShow: 2
                }
            },
            {
                breakpoint: 479,
                settings: {
                slidesToShow: 1
                }
            }
            ]
        });
        }

        // For Featured Recipes Slider
		if ($('.is-carousel').length && $.fn.slick) {
			$('.is-carousel').on('init', function(event, slick) {
				// applyCustomDots($('.featured-recipes-carousel'));
			}).slick({
				prevArrow: '<div class="prevNav"><svg width="70" height="69" viewBox="0 0 70 69" fill="none" xmlns="http://www.w3.org/2000/svg"> <g id="CaretLeft"> <path id="Vector" d="M21.3 35.2628L42.8625 56.8253C42.9627 56.9254 43.0816 57.0049 43.2125 57.0591C43.3434 57.1133 43.4837 57.1412 43.625 57.1412C43.7667 57.1412 43.9069 57.1133 44.0378 57.0591C44.1687 57.0049 44.2876 56.9254 44.3878 56.8253C44.488 56.7251 44.5674 56.6062 44.6216 56.4753C44.6758 56.3444 44.7037 56.2042 44.7037 56.0625C44.7037 55.9208 44.6758 55.7806 44.6216 55.6497C44.5674 55.5188 44.488 55.3999 44.3878 55.2997L23.5881 34.5L44.3878 13.7003C44.59 13.498 44.7037 13.2236 44.7037 12.9375C44.7037 12.6514 44.59 12.377 44.3878 12.1747C44.1855 11.9724 43.9111 11.8588 43.625 11.8588C43.3389 11.8588 43.0645 11.9724 42.8622 12.1747L21.3 33.7372C21.1995 33.8373 21.12 33.9562 21.0657 34.0871C21.0115 34.218 20.9835 34.3583 20.9835 34.5C20.9835 34.6417 21.0115 34.782 21.0657 34.9128C21.12 35.0437 21.1995 35.1626 21.3 35.2628Z" fill="#0086C4"/> </g> </svg></div>',
				nextArrow: '<div class="nextNav"><svg width="70" height="69" viewBox="0 0 70 69" fill="none" xmlns="http://www.w3.org/2000/svg"> <g id="CaretRight"> <path id="Vector" d="M48.7003 35.2628L27.1378 56.8253C27.0376 56.9254 26.9187 57.0049 26.7878 57.0591C26.6569 57.1133 26.5167 57.1412 26.375 57.1412C26.2333 57.1412 26.0931 57.1133 25.9622 57.0591C25.8313 57.0049 25.7124 56.9254 25.6122 56.8253C25.512 56.7251 25.4326 56.6062 25.3784 56.4753C25.3242 56.3444 25.2963 56.2042 25.2963 56.0625C25.2963 55.9208 25.3242 55.7806 25.3784 55.6497C25.4326 55.5188 25.512 55.3999 25.6122 55.2997L46.4119 34.5L25.6122 13.7003C25.4099 13.498 25.2963 13.2236 25.2963 12.9375C25.2963 12.6514 25.4099 12.377 25.6122 12.1747C25.8145 11.9724 26.0889 11.8588 26.375 11.8588C26.6611 11.8588 26.9355 11.9724 27.1378 12.1747L48.7003 33.7372C48.8005 33.8373 48.88 33.9562 48.9343 34.0871C48.9885 34.218 49.0165 34.3583 49.0165 34.5C49.0165 34.6417 48.9885 34.782 48.9343 34.9128C48.88 35.0437 48.8005 35.1626 48.7003 35.2628Z" fill="#0086C4"/> </g> </svg></div>',
			});
		}
    }
    
    /** Function to check and initialize slick on window resize and initial load */
    initializeSlickSlider();

    /** Initializing Slick Slider in Admin */
	if ( typeof acf !== 'undefined' ) {
		acf.addAction( 'load', function() {
			initializeSlickSlider();
		} );
	}

    // FAQ Accordion Toggle
    $('.faq-section .faq-item .collapse').hide();
    $('.faq-section .faq-item:first .collapse').show();
    $('.faq-section .faq-item:first').addClass('active');

    $('.faq-toggle').click(function() {
        let $this = $(this);
        let $currentCollapse = $this.closest('.faq-item').find('.collapse');
        let $allCollapses = $('.faq-section .faq-item .collapse');
        let $allFaqItems = $('.faq-section .faq-item');

        // Hide all collapses and remove 'active' class from all FAQ items
        $allCollapses.slideUp();
        $allFaqItems.removeClass('active');

        // Toggle current collapse
        if (!$currentCollapse.is(":visible")) {
            $currentCollapse.slideDown();
            $this.closest('.faq-item').addClass('active'); // Add 'active' class only to the parent of the clicked toggle
        }

        return false;
    });

    $('.opener').each(function() {
        $(this).append('<svg class="toggle-icon" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"> <g id="CaretDown"> <path id="Vector" d="M26.7075 12.7074L16.7075 22.7074C16.6146 22.8004 16.5043 22.8742 16.3829 22.9245C16.2615 22.9748 16.1314 23.0007 16 23.0007C15.8686 23.0007 15.7385 22.9748 15.6171 22.9245C15.4957 22.8742 15.3854 22.8004 15.2925 22.7074L5.29251 12.7074C5.10487 12.5198 4.99945 12.2653 4.99945 11.9999C4.99945 11.7346 5.10487 11.4801 5.29251 11.2924C5.48015 11.1048 5.73464 10.9994 6.00001 10.9994C6.26537 10.9994 6.51987 11.1048 6.70751 11.2924L16 20.5862L25.2925 11.2924C25.3854 11.1995 25.4957 11.1258 25.6171 11.0756C25.7385 11.0253 25.8686 10.9994 26 10.9994C26.1314 10.9994 26.2615 11.0253 26.3829 11.0756C26.5043 11.1258 26.6146 11.1995 26.7075 11.2924C26.8004 11.3854 26.8741 11.4957 26.9244 11.617C26.9747 11.7384 27.0006 11.8686 27.0006 11.9999C27.0006 12.1313 26.9747 12.2614 26.9244 12.3828C26.8741 12.5042 26.8004 12.6145 26.7075 12.7074Z" fill="#343330"/> </g> </svg>');
    });

    $('.opener').click(function(e) {
        e.preventDefault();
        var $this = $(this);
        var $toggleGroup = $this.closest('.wp-block-uagb-container').find('.toggle-group');
        var $icon = $this.find('.toggle-icon');

        $toggleGroup.slideToggle('fast', function() {
            $icon.toggleClass('rotate');
        });
    });

    // Popup
    $('.open-popup').on('click', function (e) {
        e.preventDefault();
        $('#autoRabit_popup').fadeIn();
    });

    $('#close-popup').on('click', function () {
        $('#autoRabit_popup').fadeOut();
    });

    $('#autoRabit_popup').on('click', function (e) {
        if ($(e.target).closest('.auto-popup-inner').length === 0) {
            $(this).fadeOut();
        }
    });
});


// document.addEventListener('DOMContentLoaded', function() {
//   // Function to adjust submenu position
//   function adjustSubmenuPosition() {
//       // Select top-level submenus
//       let topLevelSubmenus = document.querySelectorAll('#primary-menu li .am-submenu-list');

//       topLevelSubmenus.forEach(function(submenu) {
//           let parentLi = submenu.closest('li');  // Get the parent <li> element
//           let submenuRightEdge = submenu.getBoundingClientRect().right;
//           let submenuWidth = submenu.offsetWidth;
//           let parentLeftEdge = parentLi.getBoundingClientRect().left;
//           let screenWidth = window.innerWidth;

//           // Check if the submenu goes off the right edge of the screen
//           if (submenuRightEdge > screenWidth) {
//               submenu.style.right = '0'; // Align right edge of submenu with parent
//               submenu.style.left = 'auto';
//           } else {
//               submenu.style.left = '0'; // Align left edge of submenu with parent
//               submenu.style.right = 'auto';
//           }
//       });

//       // Handle nested submenus differently if needed
//       let nestedSubmenus = document.querySelectorAll('.am-submenu-list li .am-submenu-list');
//       nestedSubmenus.forEach(function(submenu) {
//           let submenuRightEdge = submenu.getBoundingClientRect().right;
//           let screenWidth = window.innerWidth;

//           if (submenuRightEdge > screenWidth) {
//               submenu.style.right = '100%'; // Shift left
//               submenu.style.left = 'auto';
//           } else {
//               submenu.style.left = '100%'; // Normal right extension
//               submenu.style.right = 'auto';
//           }
//       });
//   }

//   // Initial adjustment and setup resize event listener
//   adjustSubmenuPosition();
//   window.addEventListener('resize', adjustSubmenuPosition);
// });

// Readmore dynmaic function
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".read-more-container").forEach(function (container) {
        const dots = container.querySelector(".dots");
        const moreContent = container.querySelector(".read-more-content");
        const readMoreLink = container.querySelector(".read-more-link");

        readMoreLink.addEventListener("click", function () {
        if (dots.style.display === "none") {
            dots.style.display = "inline";
            moreContent.style.display = "none";
            readMoreLink.textContent = "Read more";
        } else {
            dots.style.display = "none";
            moreContent.style.display = "inline";
            readMoreLink.textContent = "Close";
        }
        });
    });
});